import React, { Component } from 'react'
import { Grid, Button} from '@material-ui/core'
import {ReactComponent as ArrowLeft} from '../../../assets/ArrowLeft.svg'
import {ReactComponent as ArrowRight} from '../../../assets/ArrowRight.svg'
import VideoCardItem from './VideoCardItem'
import Slider from "react-slick";
import { withStyles } from '@material-ui/core/styles'
import useStyles from "./styles/SectionHorizontalListStyle"
import './styles/slick.css'

class SectionHorizontalList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSlide: 0,
      isClickable: true,
    }
    // bind methods to 'this' instance
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next(){
    // Moves the slider-component one 'card' to the right.
    this.slider.slickNext();
  }

  previous() {
    // Moves the slider-component one 'card' to the left.
    this.slider.slickPrev();
  }

  render() {
    const classes = this.props.classes
    // The slider component's settings:
    const settings = {
      // settings for large screens:
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: this.state.currentSlide,
      swipe: false,
      responsive: [
        // settings for medium ("big medium screens"):
        {
          breakpoint: 1079,
          settings: {
            className: "center",
            centerMode: true,
            centerPadding: "260px",
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: this.state.currentSlide,
            swipe: false,
          }
        },
        // settings for medium ("small medium screens"):
        {
          breakpoint: 900,
          settings: {
            className: "center",
            centerMode: true,
            centerPadding: "180px",
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: this.state.currentSlide,
            swipe: false,
          }
        },
        // settings for small screens ("Big small screens"):
        {
          breakpoint: 719,
          settings: {
            className: "center",
            centerMode: true,
            centerPadding: "90px",
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: this.state.currentSlide,
            swipe: true,
            speed: 300,
            afterChange: (current) => {
              this.setState({currentSlide: current, isClickable: true});
            },
            beforeChange: (current, next) => {
              // This function causes the current slide not to be clicked upon swipe.
              this.setState({isClickable: false})
            },
          }
        },
        // settings for small screens ("Little small screens"):
        {
          breakpoint: 510,
          settings: {
            className: "center",
            centerMode: true,
            centerPadding: "30px",
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 200,
            initialSlide: this.state.currentSlide,
            swipe: true,
            afterChange: (current) => {
              this.setState({currentSlide: current, isClickable: true});
            },
            beforeChange: (current, next) => {
              // This function causes the current slide not to be clicked upon swipe.
              this.setState({isClickable: false})
            },
          }
        },
      ]
    };

    return (
      <Grid container className={classes.horizonalContainer} justify="center" alignItems='center'>
        <Grid item
          lg={12} md={12} sm={12}
        >
          <Slider ref={c=> (this.slider=c)} {...settings}>
            {this.props.playlist.map((item, index) =>
              <VideoCardItem
                isClickable = {this.state.isClickable}
                key={index}
                videoDetails={item}
                onVideoClicked={() => this.props.onVideoClicked(index)}
               />
            )}
          </Slider>
        </Grid>
        <Grid container className={`${classes.rightArrow} section-horizontal-right-arrow-container`}>
          <Button onClick={this.next} className={`${classes.arrowIconButton}`}>
            <ArrowRight className={'section-horizontal-arrows'}/>
          </Button>
        </Grid>
        <Grid container className={`${classes.leftArrow} section-horizontal-left-arrow-container`}>
          <Button onClick={this.previous} className={`${classes.arrowIconButton}`}>
            <ArrowLeft className={'section-horizontal-arrows'}/>
          </Button>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(SectionHorizontalList)
